import React, { Component } from "react";
import SharedViewProps from "../../../../../models/types/SharedViewProps";
import PaginatedDialogView from "../../components/PaginatedDialog/PaginatedDialogView";
import IntroductionViewStyle from "./IntroductionViewStyle";
import TranslationView from "../../../../components/Translation/TranslationView";
import PaginatedDialogFooterView from "../../components/PaginatedDialog/components/PaginatedDialogFooter/PaginatedDialogFooterView";

export default class IntroductionView extends Component<SharedViewProps> {

    private _style = new IntroductionViewStyle();

    private _onSubmit = () => {
        this.props.routeProps.history.push('worker-info');
    }

    render() {
        return (
            <PaginatedDialogView title='oneShotCheckRequest' subtitle='introMedicheck'>
                <div style={this._style.backgroundWrapper}>
                    <div style={{ flex : 1, display : 'flex', flexDirection : 'column' }}>
                        <div style={this._style.contentWrapper}>
                            <TranslationView style={this._style.sectionTitle}>
                                whatIsMedicheck
                            </TranslationView>

                            <TranslationView style={this._style.paragraph}>
                                whatIsMedicheckBody
                            </TranslationView>
                        </div>

                        <div style={this._style.contentWrapper}>
                            <TranslationView style={this._style.sectionTitle}>
                                checkExplanation
                            </TranslationView>

                            <TranslationView style={this._style.paragraph}>
                                checkExplanationBody
                            </TranslationView>
                        </div>
                    </div>

                    <div style={this._style.doctorWrapper}>
                        <img style={this._style.doctorBackground} src={require('./assets/doctor-bg.png')} alt='A white decorative background' />
                        <img style={this._style.doctor} src={require('./assets/doctor.png')} alt='A doctor, in front of the background' />
                    </div>
                </div>

                <PaginatedDialogFooterView numberOfPages={5} currentPage={1} onSubmit={this._onSubmit} />
            </PaginatedDialogView>
        );
    }
}